import {
  ChatBubbleLeftEllipsisIcon,
  ClipboardDocumentListIcon,
  ExclamationTriangleIcon,
  MapPinIcon,
} from "@heroicons/react/20/solid";
import { OtsTooltip } from "../components/OtsTooltip";
import { activityMutedClass } from "./driver-activity-layout";
import type { ActivityEntry } from "./driver-activity-view-model";

const plural = (count: number, noun: string) => `${count} ${noun}${count === 1 ? "" : "s"}`;

/** The one thing most worth knowing about a row: its warnings, else its latest comment, else what kind of row it is. */
export const ActivityStatusIcon = ({ entry }: { entry: ActivityEntry }) => {
  if (entry.kind === "visit") return <MapPinIcon aria-label="Site visit" className={["size-4", activityMutedClass].join(" ")}/>;
  if (entry.kind === "dispatch") return <ClipboardDocumentListIcon aria-label="Dispatch" className={["size-4", activityMutedClass].join(" ")}/>;

  if (entry.warnings.length) {
    return (
      <OtsTooltip
        density="compact"
        content={<ul className="space-y-1">{entry.warnings.map((warning) => <li key={warning.type}>{warning.message}</li>)}</ul>}>
        <ExclamationTriangleIcon tabIndex={0} aria-label={plural(entry.warnings.length, "warning")} className="size-4 text-[var(--ots-error)]"/>
      </OtsTooltip>
    );
  }
  if (entry.messages.length) {
    return (
      <OtsTooltip density="compact" content={entry.messages[entry.messages.length - 1].message}>
        <ChatBubbleLeftEllipsisIcon tabIndex={0} aria-label={plural(entry.messages.length, "comment")} className="size-4 text-[var(--ots-primary)]"/>
      </OtsTooltip>
    );
  }
  return null;
};
